'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('active')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/active.js
// module id = 364
// module chunks = 168707334958949